<!-- 加入购物车 -->
<script setup>
import { nextTick } from 'vue'
import productIMG from '@/components/productIMG/index.vue'
import { getDetail } from '@/apis/detail'
import { useUserStore } from '@/stores/userStore'
import { useCartStore } from '@/stores/cartStore'
import { exchangeRate } from '@/utils/index'
import { useI18n } from 'vue-i18n'
const { t } = useI18n();
const emits = defineEmits(['close'])

const userStore = useUserStore()
const cartStore = useCartStore()
const props = defineProps(['id'])
const userId = ref(userStore.userInfo.id)
const languages = ref()
const imageListData = ref()//商品图片
const param = reactive({
    goods: {}
})
const loginModel = ref(false);
const num = ref(1)
const inventory = ref()//商品库存
const skuId = ref()//skuid
const skuData = ref()//sku值
const properties_name = ref()
const checkedCount = ref()
const maxNum = ref()
const getGoods = async () => {
    let language = localStorage.getItem('language');
    if (language == 'zh-cn') {
        language = 'zn'
    }
    languages.value = language.toLowerCase()
    const res = await getDetail({ id: props.id, userId: userId.value })

    nextTick(() => {
        if (res.code == 0) {
            param.goods = res.data.data
            imageListData.value = JSON.parse(JSON.stringify(param.goods.images))
            if (param.goods.video != '') {
                imageListData.value.unshift(param.goods.video)

            }
            checkImg.value = param.goods?.images[0]
            console.log('规格', param.goods.variableAttr)
            if (param.goods?.variableAttr?.length == 0) {//单规格
                param.goods.price = param.goods?.skus[0].price
                maxNum.value = param.goods?.skus[0].quantity
                skuId.value = param.goods?.skus[0].id
                skuData.value = param.goods?.skus[0].sku
                checkedCount.value = []
                inventory.value = param.goods?.skus[0].quantity
                console.log('单规格', param.goods?.skus[0].quantity)
            } else {
                console.log('其他库存', param.goods?.inventory)
                inventory.value = param.goods?.inventory || 0
            }
            // 过滤出quantity等于0的产品，并获取variant_names
            const filteredVariantNames = param.goods?.skus
                .filter(product => product.quantity === 0)
                .map(product => product.variant_names);

            console.log('等于0的产品', filteredVariantNames);
             // 过滤出quantity不等于0的产品，并获取variant_names
             const nofilteredVariantNames = param.goods?.skus
                .filter(product => product.quantity != 0)
                .map(product => product.variant_names);
                console.log('不等于0的产品',nofilteredVariantNames)
            // 使用reduce方法展平数组，并使用Set过滤重复值
            const uniqueVariantNames = nofilteredVariantNames.reduce((acc, current) => {
                return acc.concat(current);
            }, []).filter((value, index, self) => {
                return self.indexOf(value) === index;
            });
            // 遍历attributes数组
            param.goods?.variableAttr.forEach(attr => {
                // 遍历每个属性的values数组
                attr.values.forEach(val => {
                    // 检查当前值是否在valuesToDisable数组中
                    if (uniqueVariantNames.includes(val.name.zn)) {
                        // 否则，设置isDisabled为false或删除该属性
                        val.isDisabled = false;
                    } else {
                       
                         // 设置isDisabled为true
                         val.isDisabled = true;
                    }
                });
            });
        }
    })


}
const checkItem = (groupIndex, itemIndex, check) => {
    if (check) {
        return
    } else {


        // 过滤出quantity不等于0的产品，并获取variant_names
        const nofilteredVariantNames = param.goods?.skus
                .filter(product => product.quantity != 0)
                .map(product => product.variant_names);
                console.log('不等于0的产品',nofilteredVariantNames)
                const uniqueVariantNames = nofilteredVariantNames.reduce((acc, current) => {
                return acc.concat(current);
            }, []).filter((value, index, self) => {
                return self.indexOf(value) === index;
            });
            console.log('过滤重复值',uniqueVariantNames)
        console.log(groupIndex, itemIndex,check)
        //点击的规格值
        let checkData = param.goods?.variableAttr[groupIndex].values[itemIndex].name.zn

        const filteredProducts = param.goods?.skus.filter(product =>
            product.variant_names.some(name => name === checkData)
        );
        console.log(filteredProducts);
        //判断选中
        for (let i = 0; i < param.goods?.variableAttr?.length; i++) {
            console.log(i, groupIndex)
            if (i == groupIndex) {
                for (let z = 0; z < param.goods?.variableAttr[i].values.length; z++) {
                    param.goods.variableAttr[i].values[z].isDisabled = false
                    if (z == itemIndex) {
                        param.goods.variableAttr[i].values[z].check = true

                    } else {
                        param.goods.variableAttr[i].values[z].check = false
                         // 检查当前值是否在uniqueVariantNames数组中
                         if (uniqueVariantNames.includes(param.goods.variableAttr[i].values[z].name.zn)) {
                            console.log('存在')
                            param.goods.variableAttr[i].values[z].check = false
                        }else{
                            param.goods.variableAttr[i].values[z].check = false
                            param.goods.variableAttr[i].values[z].isDisabled = true
                        }
                    }
                }
            } else {
                // 遍历products数组
                filteredProducts.forEach(product => {
                    // 找到values数组中与product.variant_names数组中任意元素相匹配的对象
                    const value = param.goods?.variableAttr[i].values.find(item =>
                        product.variant_names.some(name => name === item.name.zn)
                    );

                    if (value) {
                        // 根据quantity的值设置isDisabled属性
                        value.isDisabled = product.quantity === 0;
                    }
                });

            }
        }
    }
    // 使用 map 和 filter 来提取所有 "check": true 的数据
    const filteredAttributes = param.goods?.variableAttr.map(attr => ({
        name: attr.name,
        values: attr.values.filter(val => val.check)
    }));
    // 过滤掉 values 为空的对象
    checkedCount.value = filteredAttributes.filter(attr => attr.values.length > 0);
    console.log('checkedCount.value', checkedCount.value)
    if (checkedCount.value?.length == param.goods?.variableAttr?.length) {
        // 提取SKUD选中的值
        const selectedValues = checkedCount.value.flatMap(attr =>
            attr.values.filter(val => val.check).map(val => val.name[languages.value] || val.name['en_us'])
        );
        console.log(selectedValues)
        const matchingProduct = param.goods?.skus.find(product => {
            // 检查 variant_names 是否包含 targetVariants 的所有元素
            return selectedValues.every(target => product.variant_names.includes(target));
        });
        console.log('对应的sku对象', matchingProduct)
        param.goods.price = matchingProduct.price
        maxNum.value = matchingProduct.quantity
        skuId.value = matchingProduct.id
        skuData.value = matchingProduct.sku
        inventory.value = matchingProduct.quantity
        // 提取颜色和尺寸的名称
        const extractedInfo = checkedCount.value.map(attr => {
            const value = attr.values.find(val => val.check);
            return value ? `${attr.name[languages.value]|| attr.name['en_us']}：${value.name[languages.value]|| value.name['en_us']}` : null;
        }).filter(info => info); // 过滤掉未找到匹配项的 null 值
        console.log(extractedInfo); // 输出: ["颜色:白色", "尺寸:L"]
        properties_name.value = extractedInfo.join('；');

    }
}
// 添加购物车
const addCart = () => {
    if (userStore.userInfo.token) {
        console.log(111)
        // if (skuObj.skuId) {
        // 规则已经选择 触发action
        if (param.goods.variableAttr?.length == checkedCount.value?.length) {
            cartStore.addCart({
                shop_user_id: param.goods.userId,
                id: param.goods.id, // 商品id
                name: param.goods.name, // 商品名称
                picture: param.goods.coverUrl, // 图片
                needIntlPostage:param.goods.needIntlPostage,//需要国际邮费
                price: param.goods.price, // 最新价格
                description: param.goods.description, // 商品规格文本
                selected: true, // 商品是否选中
                inventory: inventory.value,//商品库存
                num: num.value,
                from: 'product',
                source: '',
                sku: skuData.value,
                edit:false,
                sku_info: {
                    sku_id: skuId.value,
                    properties_name: properties_name.value
                }
            })
            emits('closes', false)
            ElMessage({ type: 'success', message: t('setup12') })
        }

        // } else {
        //     // 规则没有选择 提示用户
        //     ElMessage.warning('请选择规格')
        // }
    } else {
        // 2. 跳转到登录页
        loginModel.value = true
    }
}
const handleClose = () => {
    loginModel.value = false
}
const checkImg = ref()
const isMobile = ref(false)
onMounted(() => {
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    nextTick(async () => {
        await getGoods()
    })


});
</script>
<template>
    <div>
        <div class="product" v-if="param.goods && isMobile == false">
            <div>
                <!-- 商品图片 -->
                <productIMG :imageList="imageListData"></productIMG>
            </div>
            <div class="spec pc" ref="specElement">

                <div class="specTop"></div>

                <div class="specTitle" style="   ">
                    <div class="spec-name">
                        {{ param.goods.name }}</div>
                    <div @click="copyText()">
                        <svg-icon icon-class="shares" style="width: 20px;height: 20px;" />
                    </div>
                </div>
                <div class="info-Browse">
                    <div class="Browse">{{ $t('setup32') }} {{ param.goods.viewsNum }}</div>
                    <!-- <div class="user-info-img" @click="goUser(param.goods.userId)">{{ $t('setup482') }}:<img
                            :src="param.goods.avatar" class="userimg"><svg-icon icon-class="yous"
                            style="    margin-left: 4px;width: 6px;height: 10px;" /></div> -->
                </div>
                <div class="info-price">
                    <div class="price">
                        <span v-if="userStore.exchangeRate.symbol == '￥'"> ¥{{ param.goods?.price }}</span>
                        <span v-else>{{ exchangeRate(param.goods?.price,
                            userStore.exchangeRate.symbol, userStore.exchangeRate.rate) }}</span>
                    </div>
                    <div class="liang">
                        {{ $t('setup439') }}&nbsp;{{ param.goods.salesCount }}
                    </div>
                    <div class="liang">
                        {{ $t('setup31') }} &nbsp;{{ inventory }}
                    </div>
                </div>
                <div class="hrdiv"></div>
                <div class="sku" v-if="param.goods?.variableAttr && param.goods?.variableAttr?.length > 0">
                    <div class="Specification" v-for="(item, index) in param.goods?.variableAttr" :key="index">
                        <div class="suktitle">{{ item.name[languages] || item.name['en_us']}}</div>
                        <div  class="skudata">
                            <!-- 表示有图片 -->
                            <div :class="[item.isImg && i.img ? i.check == true && i.isDisabled == false ? 'yesImgCheck' : 'yesImg':i.check == true && i.isDisabled == false ? 'noImgCheck' : 'noImg', i.isDisabled == true ? 'isDisabled' : '']"
                                v-for="(i, indexs) in item.values" :key="indexs"
                                @click="checkItem(index, indexs, i?.isDisabled); checkImg = i.img;">
                                <div class="img" v-if="item.isImg && i.img" ><img :src="i.img" alt="" srcset=""></div>
                                <div class="imgname"> {{ i.name[languages] }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="number">
                    <span>{{ $t('cart3') }}：</span>
                    <el-input-number v-model="num" :max="maxNum" class="mx-4" />
                </div>
                <div class="buts pc" v-if="userStore.userInfo.id != param.goods.userId">
                    <div size="large"
                        :class="[param.goods.variableAttr?.length != checkedCount?.length ? 'isDisabled' : '', 'addcart']"
                        @click="addCart">
                        {{ $t("home29") }}
                    </div>

                </div>
            </div>
        </div>
        <div class="phoneProduct" v-if="isMobile == true">

            <div class="imgPrice">
                <img :src="checkImg" alt="" srcset="" style="width: 82px;height: 82px;">
                <div class="numprice">
                    <div class="name">
                        {{ param.goods.name }}
                    </div>
                    <div class="price">
                        <span v-if="userStore.exchangeRate.symbol == '￥'"> ¥{{ param.goods.price }}</span>
                        <span v-else>{{ exchangeRate(param.goods.price,
                            userStore.exchangeRate.symbol, userStore.exchangeRate.rate) }}</span>
                    </div>
                </div>
            </div>
            <div class="sku" v-if="param.goods?.variableAttr?.length > 0">
                <div class="Specification" v-for="(item, index) in param.goods.variableAttr" :key="index">
                    <div class="suktitle">{{ item.name[languages]|| item.name['en_us'] }}</div>
                    <div  class="skudata">
                            <!-- 表示有图片 -->
                            <div :class="[item.isImg && i.img ? i.check == true && i.isDisabled == false ? 'yesImgCheck' : 'yesImg':i.check == true && i.isDisabled == false ? 'noImgCheck' : 'noImg', i.isDisabled == true ? 'isDisabled' : '']"
                                v-for="(i, indexs) in item.values" :key="indexs"
                                @click="checkItem(index, indexs, i?.isDisabled); checkImg = i.img;">
                                <div class="img" v-if="i.img && item.isImg"><img :src="i.img" alt="" srcset=""></div>
                                <div class="imgname" v-else> {{ i.name[languages] }}</div>
                            </div>
                        </div>
                </div>
            </div>
            <div class="number">
                <span>{{ $t('cart3') }}：</span>
                <el-input-number v-model="num" :max="maxNum" class="mx-4" />
            </div>

            <div class="dialog-footer" v-if="userStore.userInfo.id != param.goods.userId">
                <div class="butdiv">
                    <div class="but">
                        <div size="large"
                            :class="[param.goods.variableAttr?.length != checkedCount?.length ? 'isDisabled' : '', 'addcart']"
                            @click="addCart">
                            {{ $t("home29") }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog v-model="loginModel" width="350" :before-close="handleClose">
            <loginView :loginType="1" @close="handleClose" :type="1" v-if="loginModel"></loginView>
        </el-dialog>
    </div>
</template>
<style scoped lang="scss">
.isDisabled {
    cursor: not-allowed;
    opacity: .3;
}

.product {
    display: flex;

    -webkit-user-select: text;
    /* 允许文本选择 */
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;

    .spec {
        // width: 1200px;
        flex: 1;
        padding: 0 0 0 40px;
        // position: fixed;
        top: 171px;
        /* 固定在顶部 */
        overflow-y: auto;
        height: auto;

        /* 允许垂直滚动 */
        // border: 1px solid #ccc;
        .specTop {
            width: 580px;
            height: 28px;
            background: #FC3938;
            border-radius: 4px;
        }

        .specTitle {
            display: flex;
            justify-content: space-between;
            margin-top: 20px;
            margin-bottom: 16px;

            .spec-name {
                width: 550px;
                font-family: MicrosoftYaHei;
                font-size: 20px;
                color: #11192D;
                line-height: 26px;
                text-align: left;
                font-style: normal;
            }
        }

        .info-Browse {
            display: flex;

            .Browse {
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #777777;
                line-height: 16px;
                text-align: left;
                font-style: normal;
                padding-right: 18px;
            }

            .user-info-img {
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #11192D;
                line-height: 16px;
                text-align: left;
                font-style: normal;
                display: flex;
                align-items: center;

                .userimg {
                    width: 18px;
                    height: 18px;
                    border-radius: 50%;
                    margin-left: 5px;
                }
            }
        }

        .info-price {
            display: flex;
            padding-top: 30px;
            align-items: center;
            margin-bottom: 25px;

            .price {
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                // font-size: 15px;
                font-size: 24px;
                color: #FC3938;
                line-height: 19px;
                text-align: left;
                font-style: normal;
            }

            .liang {
                margin: 0 8px;
                padding: 5px 8px;
                background: #FEF1EA;
                border-radius: 4px;
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #FC3938;
                line-height: 16px;
                text-align: left;
                font-style: normal;
            }
        }

        .hrdiv {
            width: 580px;
            height: 1px;
            border: 1px solid #E1E1E1;
            margin-bottom: 20px;
        }

        .sku {
            .Specification {
                .suktitle {
                    font-family: MicrosoftYaHei, MicrosoftYaHei;
                    font-weight: bold;
                    font-size: 16px;
                    color: #11192D;
                    line-height: 21px;
                    text-align: left;
                    font-style: normal;
                    padding-bottom: 10px;
                }

                .skudata {
                    display: flex;
                    margin-bottom: 15px;
                    flex-wrap: wrap;
                    .noImg {
                        background: #FFFFFF;
                        border-radius: 16px;
                        border: 1px solid #E5E8EC;
                        padding: 6px 23px;
                        height: 32px;
                        margin-right: 15px;
                        margin-bottom: 10px;
                    }

                    .yesImg {
                        width: 88px;
                        height: 122px;
                        background: #FFFFFF;
                        border-radius: 8px;
                        border: 1px solid #E1E1E1;
                        margin-right: 8px;
                        margin-bottom: 5px;

                        .img {
                            width: 86px;
                            height: 94px;

                            img {
                                width: 100%;
                                height: 100%;
                                border-radius: 8px 8px 0 0;
                            }

                        }

                        .imgname {
                            padding-top: 4px;
                            font-family: MicrosoftYaHei;
                            font-size: 12px;
                            color: #0F0F0F;
                            line-height: 12px;
                            text-align: left;
                            font-style: normal;
                            text-align: center;
                        }

                    }

                    .yesImgCheck {

                        width: 88px;
                        height: 122px;
                        background: #FFFFFF;
                        border-radius: 8px;
                        border: 1px solid #0F0F0F;
                        margin-right: 8px;

                        .img {
                            width: 86px;
                            height: 94px;

                            img {
                                width: 100%;
                                height: 100%;
                                border-radius: 8px 8px 0 0;
                            }

                        }

                        .imgname {
                            padding-top: 4px;
                            font-family: MicrosoftYaHei;
                            font-size: 12px;
                            color: #0F0F0F;
                            line-height: 12px;
                            text-align: left;
                            font-style: normal;
                            text-align: center;
                        }
                    }

                    .noImgCheck {
                        padding: 6px 23px;
                        height: 32px;
                        background: #0F0F0F;
                        border-radius: 16px;
                        border: 1px solid #747474;
                        font-family: MicrosoftYaHei;
                        font-size: 14px;
                        color: #FFFFFF;
                        line-height: 19px;
                        text-align: left;
                        font-style: normal;
                        margin-right: 15px;
                    }

                    .isDisabled {
                        cursor: not-allowed;
                        opacity: .3;
                    }
                }

            }
        }

        .number {
            margin-bottom: 29px;
            display: flex;
            align-items: center;
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 16px;
            color: #11192D;
            line-height: 21px;
            text-align: left;
            font-style: normal;
        }

        .buts {
            .isDisabled {
                cursor: not-allowed;
                opacity: .3;
            }

            display: flex;
            font-family: MicrosoftYaHei,
            MicrosoftYaHei;
            font-weight: bold;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 21px;
            text-align: left;
            font-style: normal;
            justify-content: space-between;

            .addcart {
                width: 100%;
                height: 46px;
                background: #FB7700;
                border-radius: 23px;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .Buynow {
                width: 280px;
                height: 46px;
                background: #FC3938;
                border-radius: 23px;
                display: flex;
                justify-content: center;
                align-items: center;

            }
        }

        .user {
            display: flex;
            align-items: center;
            padding: 0px 10px 20px 10px;

            justify-content: space-between;

            .userimg {
                display: flex;
                align-items: center;

                .avatar {
                    width: 50px;
                    /* 设置头像的宽度 */
                    height: 50px;
                    /* 设置头像的高度 */
                    border-radius: 50%;
                    /* 使头像呈现圆形 */
                }

                .username {
                    margin-left: 10px;
                    font-size: 16px;
                }
            }

            .attention {
                .focuson {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: #f5f5f5;
                    width: 100px;
                    height: 39px;
                    border-radius: 26px;
                    font-size: 16px;
                    // font-weight: 600;
                }

                .nofocuson {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: #f5f5f5;
                    width: 100px;
                    height: 30px;
                    border-radius: 26px;
                }
            }

        }
    }
}

@media (max-width: 768px) {
    .dialog-footer {
        height: 50px;
        border-top: 1px solid #E9E9E9;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        /* 针对 iOS 的优化 */
        // transform: translateZ(0);
        -webkit-backface-visibility: hidden;
        z-index: 9999;
        background-color: #fff;
    }

    .addcart {
        margin: 5px 0;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 15px;
        color: #FFFFFF;
        line-height: 21px;
        text-align: left;
        font-style: normal;
        // width: 142px;
        padding: 0 23px;
        height: 40px;
        background: #FB7700;
        border-radius: 23px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .phoneProduct {
        .imgPrice {
            height: 82px;
            display: flex;
            // padding-bottom: 20px;
            margin-bottom: 20px;

            .numprice {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                padding-left: 10px;

                .name {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #222222;
                    line-height: 20px;
                    text-align: left;
                    font-style: normal;
                }

                .price {
                    font-family: MicrosoftYaHei, MicrosoftYaHei;
                    font-weight: bold;
                    // font-size: 15px;
                    font-size: 18px;
                    color: #FC3938;
                    line-height: 14px;
                    text-align: left;
                    font-style: normal;
                }
            }

        }

        .sku {

            // padding-top: 20px;
            .Specification {
                .suktitle {
                    font-family: MicrosoftYaHei, MicrosoftYaHei;
                    font-weight: bold;
                    font-size: 16px;
                    color: #11192D;
                    line-height: 21px;
                    text-align: left;
                    font-style: normal;
                    padding-bottom: 10px;
                }

                .skudata {
                    display: flex;
                    flex-wrap: wrap;
                    margin-bottom: 15px;
                    

                    .noImg {
                        background: #FFFFFF;
                        border-radius: 16px;
                        border: 1px solid #E5E8EC;
                        padding: 6px 23px;
                        height: 32px;
                        margin-right: 15px;
                        margin-bottom: 10px;
                    }

                    .yesImg {
                        width: 78px;
                        height: 78px;
                        background: #FFFFFF;
                        border-radius: 8px;
                        border: 1px solid #E1E1E1;
                        margin-right: 8px;
                        margin-bottom:5px;
                        .img {
                            height: 75px;
                            width: 75px;

                            img {
                                width: 100%;
                                height: 100%;
                                border-radius: 8px 8px 8px 8px;
                            }

                        }

                        .imgname {
                            padding-top: 4px;
                            font-family: MicrosoftYaHei;
                            font-size: 12px;
                            color: #0F0F0F;
                            line-height: 12px;
                            text-align: left;
                            font-style: normal;
                            text-align: center;
                        }

                    }

                    .yesImgCheck {

                        width: 78px;
                        height: 78px;
                        background: #FFFFFF;
                        border-radius: 8px;
                        border: 1px solid #0F0F0F;
                        margin-right: 8px;

                        .img {
                            width: 75px;
                            height: 75px;

                            img {
                                width: 100%;
                                height: 100%;
                                border-radius: 8px 8px 8px 8px;
                            }

                        }

                        .imgname {
                            padding-top: 4px;
                            font-family: MicrosoftYaHei;
                            font-size: 12px;
                            color: #0F0F0F;
                            line-height: 12px;
                            text-align: left;
                            font-style: normal;
                            text-align: center;
                        }
                    }

                    .noImgCheck {
                        padding: 6px 23px;
                        height: 32px;
                        background: #0F0F0F;
                        border-radius: 16px;
                        border: 1px solid #747474;
                        font-family: MicrosoftYaHei;
                        font-size: 14px;
                        color: #FFFFFF;
                        line-height: 19px;
                        text-align: left;
                        font-style: normal;
                        margin-right: 15px;
                    }

                    .isDisabled {
                        cursor: not-allowed;
                        opacity: .3;
                    }
                }

            }
        }

        .number {
            // padding-top: 20px;
            margin-bottom: 29px;
            display: flex;
            align-items: center;
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 16px;
            color: #11192D;
            line-height: 21px;
            text-align: left;
            font-style: normal;
        }
    }
}
</style>